import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class } from '../utils';
import Searcher from './Searcher';
/**
 * @class Searches PostgREST endpoint
 * @extends Searcher
 * @param {Object} options
 * @param {string} options.url URL to PostgREST endpoint
 * @param {Object[]} options.types User defined types 
 */

export default Class(Searcher, {
  initialize: function initialize(options) {
    var _this = this;

    this.options = options;
    this.source = 'PostgREST';
    this.Searcher(options);
    if (options.types) options.types.forEach(function (type) {
      _this.registerType(_this.source, type.name);
    });
  },
  fetchData: function () {
    var _fetchData = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(query, caller) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = caller;
              _context.next = 3;
              return this.query(query);

            case 3:
              _context.t1 = _context.sent;

              _context.t0.fetchSuccess.call(_context.t0, _context.t1);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetchData(_x, _x2) {
      return _fetchData.apply(this, arguments);
    }

    return fetchData;
  }(),
  query: function () {
    var _query2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(_query) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_query.hasTarget) {
                _context2.next = 6;
                break;
              }

              _context2.next = 3;
              return this.queryList(_query);

            case 3:
              return _context2.abrupt("return", _context2.sent);

            case 6:
              _context2.next = 8;
              return this.queryTypes(_query);

            case 8:
              return _context2.abrupt("return", _context2.sent);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function query(_x3) {
      return _query2.apply(this, arguments);
    }

    return query;
  }(),
  queryList: function () {
    var _queryList = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(query) {
      var type, rows, results, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, row;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              type = this.options.types.find(function (t) {
                return t.name === query.target.type;
              });
              _context3.next = 3;
              return this.queryRows(query, type);

            case 3:
              rows = _context3.sent;
              results = this.createQueryResult();
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context3.prev = 8;

              for (_iterator = rows[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                row = _step.value;
                this.addRowAsResult(results, type, row);
              }

              _context3.next = 16;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](8);
              _didIteratorError = true;
              _iteratorError = _context3.t0;

            case 16:
              _context3.prev = 16;
              _context3.prev = 17;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 19:
              _context3.prev = 19;

              if (!_didIteratorError) {
                _context3.next = 22;
                break;
              }

              throw _iteratorError;

            case 22:
              return _context3.finish(19);

            case 23:
              return _context3.finish(16);

            case 24:
              return _context3.abrupt("return", results);

            case 25:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[8, 12, 16, 24], [17,, 19, 23]]);
    }));

    function queryList(_x4) {
      return _queryList.apply(this, arguments);
    }

    return queryList;
  }(),
  queryRows: function () {
    var _queryRows = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(query, type) {
      var procedure_name, queryFunc, response, rows;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              procedure_name = type.procedure_name;
              queryFunc = procedure_name ? this.queryRPC : this.queryTable;
              _context4.next = 4;
              return queryFunc.call(this, query, type);

            case 4:
              response = _context4.sent;

              if (!Array.isArray(response)) {
                _context4.next = 7;
                break;
              }

              return _context4.abrupt("return", response);

            case 7:
              _context4.next = 9;
              return response.json();

            case 9:
              rows = _context4.sent;
              return _context4.abrupt("return", rows);

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function queryRows(_x5, _x6) {
      return _queryRows.apply(this, arguments);
    }

    return queryRows;
  }(),
  queryRPC: function () {
    var _queryRPC = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5(query, type) {
      var procedure_name, params, queryparam;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              procedure_name = type.procedure_name, params = type.params, queryparam = type.queryparam; // TODO: make it configurable to ignore empty search string or not

              if (!(query.queryString.length === 0)) {
                _context5.next = 3;
                break;
              }

              return _context5.abrupt("return", []);

            case 3:
              params[queryparam] = query.queryString;
              _context5.next = 6;
              return fetch("".concat(this.options.url, "/rpc/").concat(procedure_name), {
                method: 'POST',
                mode: 'cors',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(params)
              });

            case 6:
              return _context5.abrupt("return", _context5.sent);

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function queryRPC(_x7, _x8) {
      return _queryRPC.apply(this, arguments);
    }

    return queryRPC;
  }(),
  queryTable: function () {
    var _queryTable = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6(query, type) {
      var table_name, tsvector, qs, terms, term;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              table_name = type.table_name, tsvector = type.tsvector;
              qs = "";
              terms = query.queryString.split(' ');
              term = terms[0];
              if (term.length > 0) qs = "?select=*,".concat(tsvector, "&").concat(tsvector, "=@@.").concat(term, ":*");
              _context6.next = 7;
              return fetch("".concat(this.options.url, "/").concat(table_name).concat(qs));

            case 7:
              return _context6.abrupt("return", _context6.sent);

            case 8:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function queryTable(_x9, _x10) {
      return _queryTable.apply(this, arguments);
    }

    return queryTable;
  }(),
  queryTypeCount: function () {
    var _queryTypeCount = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee7(query, type) {
      var list;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.queryRows(query, type, 100);

            case 2:
              list = _context7.sent;
              return _context7.abrupt("return", list.length);

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function queryTypeCount(_x11, _x12) {
      return _queryTypeCount.apply(this, arguments);
    }

    return queryTypeCount;
  }(),
  queryTypes: function () {
    var _queryTypes = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee8(query) {
      var _this2 = this;

      var prefix, table_data, response, results, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _loop, _iterator2, _step2, _ret;

      return _regeneratorRuntime.wrap(function _callee8$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              prefix = '';

              if (!(query.queryString.length === 0)) {
                _context9.next = 10;
                break;
              }

              _context9.next = 4;
              return fetch("".concat(this.options.url, "/table_data"));

            case 4:
              response = _context9.sent;

              if (!(response.status === 200)) {
                _context9.next = 10;
                break;
              }

              _context9.next = 8;
              return response.json();

            case 8:
              table_data = _context9.sent;
              prefix = '~';

            case 10:
              results = this.createQueryResult();
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context9.prev = 14;
              _loop =
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _loop() {
                var t, count, row, rows, postfix, title;
                return _regeneratorRuntime.wrap(function _loop$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        t = _step2.value;
                        count = '';

                        if (!(query.queryString.length === 0 && table_data)) {
                          _context8.next = 9;
                          break;
                        }

                        row = table_data.find(function (i) {
                          return i.table_name === t.table_name;
                        });

                        if (row) {
                          _context8.next = 6;
                          break;
                        }

                        return _context8.abrupt("return", "continue");

                      case 6:
                        count = row.approximate_row_count;
                        _context8.next = 21;
                        break;

                      case 9:
                        if (!(query.queryString.length > 0)) {
                          _context8.next = 21;
                          break;
                        }

                        _context8.next = 12;
                        return _this2.queryRows(query, t);

                      case 12:
                        rows = _context8.sent;
                        count = rows.length;

                        if (!(count === 0)) {
                          _context8.next = 18;
                          break;
                        }

                        return _context8.abrupt("return", "continue");

                      case 18:
                        if (!(count === 1)) {
                          _context8.next = 21;
                          break;
                        }

                        _this2.addRowAsResult(results, t, rows[0]);

                        return _context8.abrupt("return", {
                          v: results
                        });

                      case 21:
                        postfix = count > 0 ? " (".concat(prefix).concat(count, ")") : '';
                        title = "".concat(t.plural).concat(postfix);
                        results.addNewQuery(_this2.source, t.name, title, null, query.queryString, null, null);

                      case 24:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _loop);
              });
              _iterator2 = this.options.types[Symbol.iterator]();

            case 17:
              if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                _context9.next = 29;
                break;
              }

              return _context9.delegateYield(_loop(), "t0", 19);

            case 19:
              _ret = _context9.t0;
              _context9.t1 = _ret;
              _context9.next = _context9.t1 === "continue" ? 23 : 24;
              break;

            case 23:
              return _context9.abrupt("continue", 26);

            case 24:
              if (!(typeof _ret === "object")) {
                _context9.next = 26;
                break;
              }

              return _context9.abrupt("return", _ret.v);

            case 26:
              _iteratorNormalCompletion2 = true;
              _context9.next = 17;
              break;

            case 29:
              _context9.next = 35;
              break;

            case 31:
              _context9.prev = 31;
              _context9.t2 = _context9["catch"](14);
              _didIteratorError2 = true;
              _iteratorError2 = _context9.t2;

            case 35:
              _context9.prev = 35;
              _context9.prev = 36;

              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }

            case 38:
              _context9.prev = 38;

              if (!_didIteratorError2) {
                _context9.next = 41;
                break;
              }

              throw _iteratorError2;

            case 41:
              return _context9.finish(38);

            case 42:
              return _context9.finish(35);

            case 43:
              return _context9.abrupt("return", results);

            case 44:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee8, this, [[14, 31, 35, 43], [36,, 38, 42]]);
    }));

    function queryTypes(_x13) {
      return _queryTypes.apply(this, arguments);
    }

    return queryTypes;
  }(),
  addRowAsResult: function addRowAsResult(results, type, row) {
    var name = type.name,
        title_columns = type.title_columns,
        pk_column = type.pk_column,
        geojson_column = type.geojson_column;
    var title = title_columns.map(function (c) {
      return row[c];
    }).join(' ');
    var result = results.addResult(this.source, name, title, null, null, row);
    result.id = row[pk_column];
    if (geojson_column) result.geometry = row[geojson_column];
    return result;
  },
  get: function () {
    var _get = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee9(id, typeName) {
      var type, table_name, pk_column, headers, response, row, results, result;
      return _regeneratorRuntime.wrap(function _callee9$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              type = this.options.types.find(function (t) {
                return t.name === typeName;
              });
              table_name = type.table_name, pk_column = type.pk_column;
              headers = {
                'Accept': 'application/vnd.pgrst.object+json'
              };
              _context10.next = 5;
              return fetch("".concat(this.options.url, "/").concat(table_name, "?").concat(pk_column, "=eq.").concat(encodeURIComponent(id)), {
                headers: headers
              });

            case 5:
              response = _context10.sent;
              _context10.next = 8;
              return response.json();

            case 8:
              row = _context10.sent;
              results = this.createQueryResult();
              result = this.addRowAsResult(results, type, row);
              return _context10.abrupt("return", result);

            case 12:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee9, this);
    }));

    function get(_x14, _x15) {
      return _get.apply(this, arguments);
    }

    return get;
  }()
});